import * as Bixby from '$/core';

export interface SearchState {
  isGlobalSearching: boolean;
  error?: Bixby.Models.BixbyError;
  globalResults?: Bixby.Models.SearchResult[];
}

export const GLOBAL_SEARCH_INPROGRESS = 'GLOBAL_SEARCH_INPROGRESS';
export const GLOBAL_SEARCH_SUCCESS = 'GLOBAL_SEARCH_SUCCESS';
export const GLOBAL_SEARCH_FAILURE = 'GLOBAL_SEARCH_FAILURE';

interface GlobalSearchInProgress extends Bixby.Models.BixbyAction {
  type: typeof GLOBAL_SEARCH_INPROGRESS;
}
interface GlobalSearchSuccess extends Bixby.Models.BixbyAction {
  type: typeof GLOBAL_SEARCH_SUCCESS;
}
interface GlobalSearchFailure extends Bixby.Models.BixbyAction {
  type: typeof GLOBAL_SEARCH_FAILURE;
}

export type SearchTypes = 'company' | 'client';
export type SearchActionTypes = GlobalSearchInProgress | GlobalSearchSuccess | GlobalSearchFailure;
